import { rolodex } from '~/services/serviceInstances';
import { Nullable } from '~/types/Nullable';

type WorkdayEnvironment = {
  environment: string;
  cps_host: Nullable<string>;
  wss_host: Nullable<string>;
  galahad_host: Nullable<string>;
  homepage_host: Nullable<string>;
};

type WorkdayEnvironments = {
  [key: string]: WorkdayEnvironment;
};

export const getWorkdayEnvironments =
  async (): Promise<WorkdayEnvironments> => {
    const response: WorkdayEnvironment[] = await rolodex.get(
      `/client-mapping/workday/environments`,
    );
    return response.reduce((acc, env) => {
      acc[env.environment] = env;
      return acc;
    }, {} as WorkdayEnvironments);
  };
